/**
 * Wallet add-funds / edit-recurring: pick card vs ACH percentage for display and totals.
 *
 * @param {Object} options
 * @param {string} [options.paymentMethodType='card'] Stripe-style type (`card`, `us_bank_account`).
 * @param {string|number} options.creditCommissionPercentage Hidden field value (card / wallet CC rate).
 * @param {string|number} [options.achCommissionPercentage] Hidden field value when ACH rate exists.
 * @returns {number} Effective percentage (0 when card rate is non-numeric).
 */
export function commissionPercentageForPaymentMethod ({
  paymentMethodType = 'card',
  creditCommissionPercentage,
  achCommissionPercentage
}) {
  const cc = parseFloat(creditCommissionPercentage)
  const ccRate = Number.isNaN(cc) ? 0 : cc
  let achRate = ccRate
  if (achCommissionPercentage !== undefined && achCommissionPercentage !== null && achCommissionPercentage !== '') {
    const ach = parseFloat(achCommissionPercentage)
    achRate = Number.isNaN(ach) ? ccRate : ach
  }
  if (paymentMethodType === 'us_bank_account') {
    return achRate
  }
  return ccRate
}
